export default "__VITE_ASSET__D1z095ve__"